<template>
  <RightLayout>
    <div class='row clearfix body'>
      <div class='titlecss top'>
        <span class="F3-M-27">
          {{title}}
        </span>
      </div>

      <div class='col-md-12 column conter'>
        <div class='column body-left slider'>
          <div class='labelCss'>※ 必須項目</div>
          <!-- 運行区分 -->
          <div class="row rowdiv firstRow">
            <div class='col-md-4 rowleft rowtop'>
              <span class="flag">※</span>
              <p>運行区分</p>
            </div>
            <div class="col-md-7 radiodiv">
              <label class="radio-inline" style="margin-right: 4%">
                <input class="radiobutton" type="radio" name="transportKindRadio" v-model="viewModel.transportKind" value="0" :disabled="usedStation">
                <span></span>
                <span class="F3-R-20">区域内</span>
              </label>
              <label class="radio-inline">
                <input class="radiobutton" type="radio" name="transportKindRadio" v-model="viewModel.transportKind" value="1" :disabled="usedStation">
                <span></span>
                <span class="F3-R-20">区域外</span>
              </label>
            </div>
          </div>
          <!-- 停留所区分 -->
          <div class="row rowdiv" :style="usedStation?'height: 64px;':''">
            <div class='col-md-4 rowleft rowtop'>
              <span class="flag">※</span>
              <p>停留所区分</p>
            </div>
            <!-- 停留所選択 office_flag 0:停留所 1:事務所 -->
            <div style="display: flex; flex-wrap: wrap; flex-direction: column;">
              <div class="col-md-7 radiodiv">
                <label class="radio-inline" style="margin-right: 4%">
                  <input class="radiobutton" type="radio" name="officeFlagRadio" v-model="viewModel.officeFlag" value="0" :disabled="usedStation">
                  <span></span>
                  <span class="F3-R-20">停留所</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="officeFlagRadio" v-model="viewModel.officeFlag" value="1" :disabled="usedStation">
                  <span></span>
                  <span class="F3-R-20">事務所</span>
                </label>
              </div>
              <div v-show="usedStation" style="margin-left:10px; text-align:left; color:red;">※この停留所はルートに使用されているため、区分を変更できません。</div>
            </div>
          </div>
          <div class='row rowdiv'>
            <div class='col-md-4 rowleft rowtop'>
              <span class="flag">※</span>
              <p>停留所名</p>
            </div>
            <div class='col-md-7'>
              <input
              name='stationName'
              class='rowinput'
              maxlength="50"
              style="padding-left:10px;"
              type='text'
              v-model='viewModel.stationName'
              v-validate="'required|paintWordNo'" />
            </div>
          </div>
          <div v-if="errors.has('stationName')" class="errorMessageDiv">
            <label class='errorMessage'> {{ errors.first('stationName') }} </label>
          </div>

          <div v-if="windowType == '2'" class='row rowdiv'>
            <div class='col-md-5 rowleft rowtop'>停留所ID</div>
            <div class='col-md-7'><input class='rowinput rowtop disabledrow F3-R-20' type='text' v-model='viewModel.displayStationId' disabled='disabled' /></div>
          </div>

          <div class='row rowdiv' style="display:none">
            <div class='col-md-4 rowleft rowtop'>地点名称</div>
            <div class='col-md-7'><input class='rowinput rowtop disabledrow F3-R-17' type='text' v-model='viewModel.addressName' disabled='disabled' /></div>
          </div>
          <div class='row rowdiv'>
            <div class='col-md-4 rowleft rowtop'>所在地</div>
            <div class='col-md-7'><input class='rowinput rowtop disabledrow F3-R-17' type='text' v-model='viewModel.address' disabled='disabled' /></div>
          </div>
          <div class='row rowdiv'>
            <div class='col-md-4 rowleft rowtop'>緯度</div>
            <div class='col-md-7'><input class='rowinput rowtop disabledrow F3-R-20' type='text' v-model='viewModel.stationLat' disabled='disabled' /></div>
          </div>
          <div class='row rowdiv'>
            <div class='col-md-4 rowleft rowtop'>経度</div>
            <div class='col-md-7'><input class='rowinput rowtop disabledrow F3-R-20' type='text' v-model='viewModel.stationLng' disabled='disabled' /></div>
          </div>
          <div class='row rowdiv'>
            <div class='col-md-7 rowleft_last rowtop'>コメント</div>
            <div class='col-md-7'>
              <textarea name='note' class='rowtextarea rowtop F3-R-20' maxlength="256" style="padding-left:10px" rows='16' v-model='viewModel.note' v-validate="'paintWordNo'"></textarea>
            </div>
          </div>
          <div class='row rowdiv' v-if="errors.has('note')">
              <div class="col-md-7 errorMessageDiv2">
                <label class='errorMessage'> {{ errors.first('note') }} </label>
              </div>
          </div>
        </div>

        <div class=' column body-right'>
          <div class='inputdiv'>
            <input type='text' title='検索' placeholder='検索' v-model='searchAddress' @blur='searchPlaceEvnet' @keydown.enter='searchPlaceEvnet' />
          </div>
          <div class='map-class'>
            <GoogleMap ref='gMap' :center-point='centerPoint' :map-id='mapId' @mapLeftClickEvent='mapLeftClickEventFunc'>
            </GoogleMap>
          </div>
        </div>
      </div>

      <div class='col-md-12 clearfix foot'>
        <div class="edit col-md-6" :href='hrefValue' data-toggle='modal'>
          <button class='column button bottomleft  F2-M-24' @click='whenOpenSaveWindow' onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
            {{ windowTypes === '1' ? '登録': '保存'}}
          </button>
        </div>
        <div class="cancel col-md-6">
          <button class='column button bottomright  F2-M-24' @click='goback'>キャンセル</button>
        </div>
      </div>
    </div>

    <station-save-window-mask ref='saveWindowDiv'></station-save-window-mask>
    <CheckDialog v-show='showDialog' :dialog-option='dialogOption' ref='dialogWindow'></CheckDialog>
  </RightLayout>
</template>

<script>
import RightLayout from '../layouts/rightLayout'
import GoogleMap from '@/components/googleMap'
import StationSaveWindowMask from '@/components/stationSaveWindowMask'
import CheckDialog from '@/components/Dialog'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
import STATION_DROP_PIN from '@/assets/map_icon/map_drop_pin.png'

export default {
  data () {
    return {
      windowType: '1',
      mapId: 'mapReg',
      // 地图中心点
      centerPoint: {},
      title: '停留所を登録',
      viewModel: {
        stationName: '',
        stationId: '',
        displayStationId: '',
        addressName: '',
        address: '',
        stationLat: '',
        stationLng: '',
        note: '',
        createUser: '',
        // 運行区分
        transportKind: 0,
        // 停留所区分
        officeFlag: 0,
      },
      searchAddress: '',
      hrefValue: '',

      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '地点が選択されてません。マップから検索してください。',
        confirmButtonText: 'OK'
      },
      // 地图图标标记点
      pointDataList: [],
      obj: null,
      // 停留所使用フラグ
      usedStation: false
    }
  },
  components: {
    RightLayout,
    GoogleMap,
    StationSaveWindowMask,
    CheckDialog
  },
  async mounted () {
    await this.initDataAndMap()
  },
  computed: {
    windowTypes () {
      // 1: 登録 ，2: 保存
      return sessionStorage.getItem('windowType')
    }
  },
  methods: {
    async initMap () {

    },
    async initDataAndMap () {
      // 判断从哪个页面进入的
      // windowType: 1 => 注册方式
      // windowType: 2 => 编辑方式
      this.windowType = sessionStorage.getItem('windowType')
      await this.$refs.gMap.initializeGoogleMap()
      let stationPoint = {
        lat: this.centerPoint.lat,
        lng: this.centerPoint.lng,
        icon: STATION_DROP_PIN
      }
      let imgSize = {width: 20, height: 54}
      // 可以在地图上添加点标记
      this.$refs.gMap.addDoubleClickEvent(stationPoint, imgSize)

      if (this.windowType === '2') {
        // 具体数据
        this.viewModel = JSON.parse(sessionStorage.getItem('stationViewModel')) || {}
        // 从上个页面传过来的地图标记点
        // let { stationId, stationLat, stationLng } = JSON.parse(sessionStorage.getItem('pointDataList')) || {}
        let { stationId } = JSON.parse(sessionStorage.getItem('pointDataList')) || {}
        this.title = '停留所を編集'
        this.centerPoint = {
          lng: parseFloat(this.viewModel.stationLng),
          lat: parseFloat(this.viewModel.stationLat)
        }
        this.$refs.gMap.centerPointObj = this.centerPoint
        this.$refs.gMap.map.setCenter(this.centerPoint)
        this.$refs.gMap.map.setZoom(15)
        let markPosition03 = {
          label: stationId,
          lng: this.viewModel.stationLng,
          lat: this.viewModel.stationLat,
          icon: STATION_ICON
        }
        // 添加图标
        let imgSize03 = {width: 45, height: 60}
        let className03 = 'staion03-label-class'
        // 图标里面的字体样式
        let labelAnchor03 = {width: 23, height: 53}
        this.$refs.gMap.addSingleMaker(markPosition03, imgSize03, className03, labelAnchor03)

        let param = this.$qs.stringify({stationId:this.viewModel.stationId})
        this.$axios.post('station/isUsedStation', param).then(response => {
          if(response.data.result === 1){
            this.usedStation = true
          }else{
            this.usedStation = false
          }
        })
      }

      // 添加中心点标记
      if (this.windowType === '1') {
      }
    },
    goback () {
      if (this.windowType === '2') {
        this.$router.push({ name: 'StationDetail' })
      } else {
        this.$router.push({ name: 'StationList' })
      }
    },
    mapLeftClickEventFunc (eventObj) {
      this.viewModel.stationLat = eventObj.lat.toFixed(6)
      this.viewModel.stationLng = eventObj.lng.toFixed(6)
      if (eventObj.placeName) {
        this.viewModel.addressName = eventObj.placeName.trim()
      } else {
        this.viewModel.addressName = ''
      }
      if (eventObj.address) {
        this.viewModel.address = eventObj.address.trim()
      } else {
        this.viewModel.address = ''
      }
    },
    // 检索
    searchPlaceEvnet () {
      this.$refs.gMap.seachAndLocatePlaceProcess(this.searchAddress).then(latLng => {
        var latLngOjb = { lat: latLng.lat(), lng: latLng.lng() }
        // 设置图标样式
        let vehiclePoint = {
          lat: latLngOjb.lat,
          lng: latLngOjb.lng,
          icon: STATION_DROP_PIN
        }
        // 设置图标大小
        let imgSize = {width: 20, height: 54}
        this.$refs.gMap.searchAddressInfoProcess(latLngOjb, vehiclePoint, imgSize)
      }).catch(error => {
        console.log(error)
      })
    },
    // 保存 || 登录
    whenOpenSaveWindow () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.checkLatLng()) {
            return
          }
          this.hrefValue = '#modal-container-staySave'
          this.$refs.saveWindowDiv.viewModel = this.viewModel

          if (this.windowType === '2') {
            this.$refs.saveWindowDiv.changeRowValue = this.viewModel.displayStationId
          } else {
            this.$refs.saveWindowDiv.changeRowValue = this.viewModel.addressName
          }
          var center = {
            lat: this.$refs.gMap.map.getCenter().lat(),
            lng: this.$refs.gMap.map.getCenter().lng()
          }
          this.$refs.saveWindowDiv.centerPoint = center
          var zoom = this.$refs.gMap.map.getZoom()
          this.$refs.saveWindowDiv.zoom = zoom
          // 初始化子组件页面 并且赋值
          this.$refs.saveWindowDiv.initiGoogleMap()
        } else {
          this.hrefValue = ''
        }
      })
    },
    checkLatLng () {
      if (this.viewModel.stationLat === '' ||
        this.viewModel.stationLng === '' ||
        this.viewModel.stationLat === undefined ||
        this.viewModel.stationLng === undefined) {
        this.showDialog = true
        this.$refs.dialogWindow
          .confirm()
          .then(() => {
            this.showDialog = false
            //
          })
          .catch(() => {
            this.showDialog = false
          })
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
    display: flex;
    flex-direction: column;
    height: 100%;
    .top {
        height: 50px;
        margin-top: 30px;
        height: 40px;
        text-align: center;
        font-size: 26px;
    }
    .conter {
        display: flex;
        flex: 1;
        .body-left {
            flex: 1;
            padding-right: 10px;
            .labelCss {
                font-size: 14px;
                text-align: left;
                margin-left: 60px;
                // padding-right: 64%;
            }
        }
        .body-right {
            display: flex;
            flex-direction: column;
            flex: 1;
            .inputdiv {
                border: solid 2px #ccc;
                border-radius: 10px;
                width: 98%;
                height: 40px;
                background: url(../../assets/select.png) no-repeat 10px center;
                margin-left: 0px;
                margin-top: 15px;
            }
            .inputdiv input {
                float: left;
                border: none;
                background: none;
                outline: none;
                height: 40px;
                line-height: 40px;
                width: 100%;
                /* 可以对应调整.text中的backgroud和下面的text-indent调整图标和input输入地方的间距 */
                text-indent: 50px;
            }
        }
    }
    .foot {
        height: 100px;
        padding-top: 20px;
        .edit {
            display: flex;
            justify-content: flex-end;
            flex: 1;
            .buttonleft {
                height: 55px;
                width: 70%;
            }
        }
        .cancel {
            display: flex;
            justify-content: flex-start;
            flex: 1;
            .buttonright {
                height: 55px;
                width: 70%;
            }
        }
    }
}
.firstRow {
    // margin-top: -20px;
}

.rowdiv {
    height: 46px;
}
.rowleft {
    height: 40px;
    text-align: center;
    // margin-top: 20px;
    margin-left: 40px;
    width: 170px;
    min-width: 145px;
    line-height: 40px;
    background-color: rgb(218, 225, 230);
    font-family: "Noto Sans CJK JP";
    color: rgb(80, 80, 80);
    font-size: 15px;
    font-weight: 400;
}
.rowleft_last {
    height: 170px;
    text-align: center;
    // margin-top: 20px;
    margin-left: 40px;
    width: 170px;
    min-width: 145px;
    line-height: 170px;
    background-color: rgb(218, 225, 230);
    font-family: "Noto Sans CJK JP";
    color: rgb(80, 80, 80);
    font-size: 15px;
    font-weight: 400;
}
.rowinput {
    height: 40px;
    font-size: 16px;
    // margin-top: 20px;
    width: 118%;
    width: 118%;
    border: 2px solid #f1f1f1;
}
.rowtop {
    // margin-top: 6px;
}
.rowtextarea {
    font-size: 2em;
    /* margin-top: 10px; */
    width: 118%;
    border: 2px solid rgb(220, 220, 220);
    height: 170px;
    resize: none;
}
.map-class {
    width: 98%;
    height: 100%;
    padding-top: 10px;
    margin-right: 20px;
}
.button {
    width: 70%;
    height: 50px;
    background: linear-gradient(#70b6ca 50%, #48a3be 50%);
    border-radius: 10px;
    font-size: 20px;
    color: #fff;
    border: 0;
}
.foot {
    height: 70px;
    margin-top: 20px;
    position: relative;
    .bottomleft {
        display: block;
        position: absolute;
        right: 20px;
    }
    .bottomright {
        display: block;
        position: absolute;
        left: 20px;
    }
}
.disabledrow {
    padding-left: 10px;
    background-color: rgb(241, 241, 241);
}
a:hover {
    color: rgb(255, 255, 255);
}
a:link {
    color: rgb(255, 255, 255);
}

.errorMessageDiv {
    height: 24px;
    text-align: left;
    // margin-top: 23px;
    margin-left: 210px;
}
.errorMessageDiv2{
    text-align: left;
    margin-left: 210px;
}
.errorMessage {
    position: relative;
    color: red;
}
.flag {
    position: absolute;
    left: 10px;
}
.radiodiv {
  border-radius: 10px;
  width: 250px;
  height: 40px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/router/views/StationList_Registration.vue